import * as log from 'loglevel';

export const markDownParser = (rawContent) => {
  // Break it into sections by delimiter
  let splittedArray = rawContent.split(/===/g);
  // The first line is always noise
  splittedArray.shift();

  const results = [];
  splittedArray.forEach((section, index) => {
    // we create the ID from the sentence on the same line as delimiter
    try {
      const sectionArray = section.split('\n');
      const sectionId = sectionArray[0].trim().toLowerCase().replace(/\s/g, '-');
      results[index] = {
        sectionId,
        title: sectionArray[0].trim(),
        content: section.slice(sectionArray[0].length),
      };
    } catch (e) {
      log.error(e, `[Error markDownParser] issue with section ${index + 1}: \n\n${section}`);
    }
  });

  return results;
};



// WEBPACK FOOTER //
// ./src/utils/markDown.js